import axios from 'axiosConfig';

export const deleteCollateralType = (CollateralTypeID) => axios.delete(`/api/collateraltype/deletecollateraltype/${CollateralTypeID}`);

export const addCollateralType = (newCollateralType) => axios.post("/api/collateraltype/addcollateraltype", newCollateralType, {});

export const getAllCollateralType = (userID) => axios.get("/api/collateraltype/getcollateraltypes", {});

export const updateCollateralType = (collateralType) => axios.put("/api/collateraltype/updatecollateraltype", collateralType, {});

export const reactivateCollateralType = (id) => axios.put(`/api/collateraltype/reactivatecollateraltype/${id}`);

